const selectResponsibleTypes = [
  { id: '1', name: 'Cadastro' },
  { id: '2', name: 'Captação' },
  { id: '3', name: 'Indicação' },
  { id: '4', name: 'Responsável' },
];

export default selectResponsibleTypes;
